import React, { useEffect, useState } from "react"
import Card from "./Card"
import "./Rubros.css"
import tec from "./tec.png"
import { useNavigate } from "react-router-dom"
import api from "../../../httpd/api"
import Espanol from "../../../Components/Ingles/Espanol";
import Ingles from "../../../Components/Ingles/Ingles";
import FooterMovil from "../../../Components/FooterMovil/FooterMovil"

const Rubros = () => {

  const navigate = useNavigate()

  const [categorias, setCategorias] = useState([])
  const [matrix, setMatrix] = useState({})
  const [loading, setLoading] = useState(false)
  const [isEnglish, setisEnglish] = useState(0);
  const [oneSelected, setOneSelected] = useState(false)

  async function recolecDatos() {
    const categorias = await api.getRubros()
    if (categorias === false) {
      console.log("error al tratar de conseguir los rubros")
      return
    }

    const tempMatrix = {}

    let selectedRubros = [];

    for (let idCategoria = 1; idCategoria <= categorias.length; idCategoria++) {
      let checkedItemsCategoria = localStorage.getItem(`itemsChecked-${idCategoria}`)
      if (checkedItemsCategoria) {
        selectedRubros.push(...(JSON.parse(checkedItemsCategoria)) ?? [])
      }
    }

    categorias.map((categoria) => {
      const catId = categoria.id
      const rubros = categoria.rubros
      const rubrosMatrix = {}
      rubros.map((rubro) => {
        if (selectedRubros[rubro.id - 1]) {
          setOneSelected(true);
          rubro.is_selected = true;
          rubrosMatrix[rubro.id] = true;
        } else {
          rubro.is_selected = false;
          rubrosMatrix[rubro.id] = false;
        }
      })
      return tempMatrix[catId] = rubrosMatrix
    })

    setCategorias(categorias)
    setMatrix(tempMatrix)
    setLoading(true)
  }

  const onSubmitR = async () => {
    localStorage.setItem("rubsSelected", JSON.stringify(matrix))
    navigate("../costo")
  }

  const NavAtras = () => {
    navigate("../")
  }

  const handleMatrixChange = (idCategoria, idRubro, checked) => {
    const newMatrix = { ...matrix }
    newMatrix[idCategoria][idRubro] = checked
    setMatrix(newMatrix)

    // Este código cambia la variable 'oneSelected' a true si al menos uno de los rubros está seleccionado
    // Si ninguno lo está, la guarda como false
    let atLeastOne = false
    for (const categoria in newMatrix) {
      for (const rubro in newMatrix[categoria]) {
        if (newMatrix[categoria][rubro]) {
          atLeastOne = true
        }
      }
    }
    if (atLeastOne) {
      setOneSelected(true)
    }
    else {
      setOneSelected(false)
    }

  }

  useEffect(() => {
    if (localStorage.getItem("ingles") == null) {
      localStorage.setItem("ingles", 0) // si no hay una opción seleccionada lo pongo en español
    }
    setisEnglish(localStorage.getItem("ingles"))
    recolecDatos()
  }, [])

  return (
    <>
      {
        isEnglish == 0 ? <Espanol handleEvent={setisEnglish} /> : <Ingles handleEvent={setisEnglish} />
      }
      <div className="rubro">

        <img className="logotec" src={tec} alt="Tec logo" onClick={NavAtras} />

        <p className="azul"> {isEnglish == 0 ? "Selecciona las categorías de tu interés" : "Select the categories of your interest"}</p>
        <div className="containerbtnbottom justify-content-center">
          <div className="row">
            <div className="column">
              {loading &&
                categorias &&
                <div key={categorias[0].id}>
                  <Card
                    imgSource={"./logos/" + categorias[0].icono}
                    title={isEnglish == 0 ? categorias[0].name : categorias[0].name_e }
                    data={categorias[0].rubros}
                    isEnglish={isEnglish}
                    idCategoria={categorias[0].id}
                    handleMatrixChange={handleMatrixChange}
                  ></Card>
                </div>
              }
            </div>
            <div className="column">
              {loading &&
                categorias &&
                <div key={categorias[1].id}>
                  <Card
                    imgSource={"./logos/" + categorias[1].icono}
                    title={isEnglish == 0 ? categorias[1].name : categorias[1].name_e }
                    data={categorias[1].rubros}
                    isEnglish={isEnglish}
                    idCategoria={categorias[1].id}
                    handleMatrixChange={handleMatrixChange}
                  ></Card>
                </div>
              }
              {loading &&
                categorias &&
                <div key={categorias[2].id}>
                  <Card
                    imgSource={"./logos/" + categorias[2].icono}
                    title={isEnglish == 0 ? categorias[2].name : categorias[2].name_e }
                    data={categorias[2].rubros}
                    isEnglish={isEnglish}
                    idCategoria={categorias[2].id}
                    handleMatrixChange={handleMatrixChange}
                  ></Card>
                </div>
              }
            </div>
            <div className="column">
            {loading &&
                categorias &&
                <div key={categorias[3].id}>
                  <Card
                    imgSource={"./logos/" + categorias[3].icono}
                    title={isEnglish == 0 ? categorias[3].name : categorias[3].name_e }
                    data={categorias[3].rubros}
                    isEnglish={isEnglish}
                    idCategoria={categorias[3].id}
                    handleMatrixChange={handleMatrixChange}
                  ></Card>
                </div>
              }
              {loading &&
                categorias &&
                <div key={categorias[4].id}>
                  <Card
                    imgSource={"./logos/" + categorias[4].icono}
                    title={isEnglish == 0 ? categorias[4].name : categorias[4].name_e }
                    data={categorias[4].rubros}
                    isEnglish={isEnglish}
                    idCategoria={categorias[4].id}
                    handleMatrixChange={handleMatrixChange}
                  ></Card>
                </div>
              }
            </div>
          </div>
          <button className="botonregresar" onClick={NavAtras}>
            {isEnglish == 0 ? 'Regresar' : 'Return'}
          </button>
          <button className="botonrubro" onClick={onSubmitR} disabled={!oneSelected}>
            {isEnglish == 0 ? 'Continuar' : 'Continue'}
          </button>
        </div>
        <FooterMovil />
      </div>
    </>
  )
}

export default Rubros
